/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LootBoxInstanceSource = {
    PURCHASE: 'PURCHASE',
    LEVEL_UP: 'LEVEL_UP',
    QUEST_REWARD: 'QUEST_REWARD',
    COMPETITION: 'COMPETITION',
    STREAK: 'STREAK',
    GIFT: 'GIFT',
    REWARD_DISTRIBUTION: 'REWARD_DISTRIBUTION'
} as const;
export type LootBoxInstanceSource = typeof LootBoxInstanceSource[keyof typeof LootBoxInstanceSource];


export function instanceOfLootBoxInstanceSource(value: any): boolean {
    for (const key in LootBoxInstanceSource) {
        if (Object.prototype.hasOwnProperty.call(LootBoxInstanceSource, key)) {
            if (LootBoxInstanceSource[key as keyof typeof LootBoxInstanceSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LootBoxInstanceSourceFromJSON(json: any): LootBoxInstanceSource {
    return LootBoxInstanceSourceFromJSONTyped(json, false);
}

export function LootBoxInstanceSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootBoxInstanceSource {
    return json as LootBoxInstanceSource;
}

export function LootBoxInstanceSourceToJSON(value?: LootBoxInstanceSource | null): any {
    return value as any;
}

export function LootBoxInstanceSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): LootBoxInstanceSource {
    return value as LootBoxInstanceSource;
}

